<template>
  <p class="emh-ui-newsletter-meta">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'NewsletterMeta',
};
</script>

<style lang="scss" scoped>
.emh-ui-newsletter-meta {
  @include wb-type-hint;
  @include wb-spacing('margin-bottom', 'xxs');

  margin-top: calc(var(--wb-spacing-xxs) * -1);
  color: var(--ui-newsletter-meta, var(--wb-grey-45));
}
</style>
